var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTakePhotoCover = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 330,
    viewBox: "0 0 330 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.771 237.376C120.276 237.376 152.302 205.35 152.302 165.845C152.302 126.339 120.276 94.314 80.771 94.314C41.2657 94.314 9.24023 126.339 9.24023 165.845C9.24023 205.35 41.2657 237.376 80.771 237.376Z",
    fill: "#FD6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.549 237.376C290.055 237.376 322.08 205.35 322.08 165.845C322.08 126.339 290.055 94.314 250.549 94.314C211.044 94.314 179.019 126.339 179.019 165.845C179.019 205.35 211.044 237.376 250.549 237.376Z",
    fill: "#7B7DFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.817 113.705H211.662C210.933 113.705 210.342 114.296 210.342 115.025V163.508C210.342 164.237 210.933 164.828 211.662 164.828H280.817C281.546 164.828 282.137 164.237 282.137 163.508V115.025C282.137 114.296 281.546 113.705 280.817 113.705Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280.817 164.829H211.662C210.933 164.829 210.342 165.42 210.342 166.149V214.632C210.342 215.361 210.933 215.952 211.662 215.952H280.817C281.546 215.952 282.137 215.361 282.137 214.632V166.149C282.137 165.42 281.546 164.829 280.817 164.829Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M284.552 113.982H215.345C214.63 113.982 214.051 114.561 214.051 115.276V163.97C214.051 164.685 214.63 165.264 215.345 165.264H284.552C285.267 165.264 285.846 164.685 285.846 163.97V115.276C285.846 114.561 285.267 113.982 284.552 113.982Z",
    fill: "#F7F7F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M284.552 165.264H215.345C214.63 165.264 214.051 165.843 214.051 166.558V215.253C214.051 215.967 214.63 216.546 215.345 216.546H284.552C285.267 216.546 285.846 215.967 285.846 215.253V166.558C285.846 165.843 285.267 165.264 284.552 165.264Z",
    fill: "#F7F7F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.754 165.264C215.754 165.264 248.226 155.008 284.13 165.264H215.754Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M221.733 165.264L278.995 166.967C278.995 166.967 282.414 166.967 284.117 170.386C285.819 173.805 285.819 175.943 285.819 175.943V167.917C285.819 167.917 285.885 165.251 284.143 165.251H221.72L221.733 165.264Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M244.398 177.223H220.889V202.858H244.398V177.223Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M277.292 177.223H249.942V182.345H277.292V177.223Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M268.66 189.183H249.942V190.885H268.66V189.183Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M268.66 196.02H249.942V197.723H268.66V196.02Z",
    fill: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268.66 199.439H249.942V201.142H268.66V199.439Z",
    fill: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 211.411H220.889V213.114H280.711V211.411Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M280.711 207.992H220.889V209.695H280.711V207.992Z",
    fill: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M268.739 185.764H249.942V187.466H268.739V185.764Z",
    fill: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280.698 199.439H272.158V201.142H280.698V199.439Z",
    fill: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M222.592 182.345C225.42 182.345 227.713 180.052 227.713 177.223C227.713 174.395 225.42 172.102 222.592 172.102C219.763 172.102 217.47 174.395 217.47 177.223C217.47 180.052 219.763 182.345 222.592 182.345Z",
    fill: "#999999"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M233.138 192.707C235.551 192.707 237.507 190.75 237.507 188.337C237.507 185.924 235.551 183.968 233.138 183.968C230.725 183.968 228.769 185.924 228.769 188.337C228.769 190.75 230.725 192.707 233.138 192.707Z",
    fill: "#E6E6E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M229.825 194.304H236.452C239.224 194.304 241.481 196.561 241.481 199.333V202.026C241.481 202.594 241.019 203.043 240.464 203.043H225.812C225.245 203.043 224.796 202.581 224.796 202.026V199.333C224.796 196.561 227.053 194.304 229.825 194.304Z",
    fill: "#E6E6E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M197.987 101.943H188.549V111.487",
    stroke: "#1DC7B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M304.907 101.943H314.345V111.487",
    stroke: "#1DC7B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M197.987 229.746H188.549V220.216",
    stroke: "#1DC7B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M304.907 229.746H314.345V220.216",
    stroke: "#1DC7B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1479 177.369L43.9955 175.468L43.7579 199.677L35.8511 190.186L38.1479 177.369Z",
    fill: "#998675"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.952 111.791H43.7975C43.0685 111.791 42.4775 112.382 42.4775 113.111V161.595C42.4775 162.324 43.0685 162.915 43.7975 162.915H112.952C113.681 162.915 114.272 162.324 114.272 161.595V113.111C114.272 112.382 113.681 111.791 112.952 111.791Z",
    fill: "#999999"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M112.253 203.043L44.3783 214.051C43.3355 214.051 42.4775 213.207 42.4775 212.151V164.815C42.4775 163.773 43.3223 162.915 44.3783 162.915H112.385C113.428 162.915 114.286 163.759 114.286 164.815L112.253 203.043Z",
    fill: "#999999"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M116.675 112.068H47.4674C46.753 112.068 46.1738 112.647 46.1738 113.361V162.056C46.1738 162.771 46.753 163.35 47.4674 163.35H116.675C117.389 163.35 117.969 162.771 117.969 162.056V113.361C117.969 112.647 117.389 112.068 116.675 112.068Z",
    fill: "#F7F7F7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M117.969 204.956L48.0482 214.632C47.0186 214.632 46.1738 213.8 46.1738 212.758V165.224C46.1738 164.195 47.0054 163.35 48.0482 163.35H116.094C117.124 163.35 117.969 164.182 117.969 165.224V204.956Z",
    fill: "#F7F7F7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8896 163.35C47.8896 163.35 80.3617 153.093 116.266 163.35H47.8896Z",
    fill: "#CCCCCC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8691 163.35L111.131 165.053C111.131 165.053 114.55 165.053 116.252 168.472C117.955 171.891 117.955 174.029 117.955 174.029V166.003C117.955 166.003 118.021 163.337 116.279 163.337H53.8691V163.35Z",
    fill: "#E6E6E6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5204 175.309H53.0112V200.943H76.5204V175.309Z",
    fill: "#CCCCCC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.428 175.309H82.0776V180.431H109.428V175.309Z",
    fill: "#CCCCCC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M100.795 187.282H82.0776V188.985H100.795V187.282Z",
    fill: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M100.795 194.119H82.0776V195.822H100.795V194.119Z",
    fill: "#CCCCCC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M100.795 197.538H82.0776V199.241H100.795V197.538Z",
    fill: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M100.874 183.863H82.0776V185.566H100.874V183.863Z",
    fill: "#CCCCCC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M112.833 197.538H104.293V199.241H112.833V197.538Z",
    fill: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7271 180.431C57.5556 180.431 59.8487 178.138 59.8487 175.309C59.8487 172.481 57.5556 170.188 54.7271 170.188C51.8985 170.188 49.6055 172.481 49.6055 175.309C49.6055 178.138 51.8985 180.431 54.7271 180.431Z",
    fill: "#808080"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M65.274 190.806C67.687 190.806 69.6432 188.85 69.6432 186.437C69.6432 184.024 67.687 182.067 65.274 182.067C62.8609 182.067 60.9048 184.024 60.9048 186.437C60.9048 188.85 62.8609 190.806 65.274 190.806Z",
    fill: "#E6E6E6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9608 192.39H68.5872C71.3592 192.39 73.6164 194.647 73.6164 197.419V200.112C73.6164 200.68 73.1544 201.129 72.6 201.129H57.948C57.3804 201.129 56.9316 200.667 56.9316 200.112V197.419C56.9316 194.647 59.1888 192.39 61.9608 192.39Z",
    fill: "#E6E6E6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M42.438 176.523V188.483L97.0332 207.847L117.929 204.956L42.438 176.523Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M42.4775 171.429L117.968 201.142V195.822L42.4775 166.861V171.429Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1104 209.391C18.9288 211.82 22.8624 222.314 31.5084 229.759C31.8648 230.063 32.4192 229.997 32.6964 229.614C34.3068 227.343 39.2436 220.519 40.2336 220.691C40.2336 220.691 48.9456 221.205 50.4108 220.374C51.7308 219.621 59.202 214.394 60.6012 213.417C60.7068 213.338 60.654 213.233 60.588 213.127C57.0108 206.817 48.6816 203.597 49.302 202.197C50.622 199.28 51.0312 194.225 51.6516 188.667C52.272 183.11 50.4372 180.602 51.0708 179.124C51.7044 177.645 55.7436 169.501 56.166 168.511C56.166 168.511 62.3304 163.587 63.162 161.621C63.9936 159.654 66.3696 155.443 63.0696 152.288C63.0696 152.288 62.7924 151.589 60.2712 153.423C57.75 155.258 55.0968 158.769 54.186 159.548C53.2752 160.327 48.1536 162.795 46.8336 164.551C45.5004 166.307 37.3824 174.477 36.9732 175.454C36.564 176.431 30.3336 188.311 25.806 200.323C25.806 200.323 24.9744 202.29 23.8524 203.557C22.9284 204.6 19.536 207.53 18.3612 208.547C18.1104 208.758 18.018 209.101 18.1236 209.405L18.1104 209.391Z",
    fill: "#C7B299"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7469 157.093L58.6213 157.885C58.8721 157.991 59.1625 157.965 59.3869 157.819C60.3637 157.173 62.9905 155.272 63.7693 153.094C63.7693 153.094 64.1257 152.737 62.6341 151.84C62.4625 151.734 62.2645 151.708 62.0797 151.774C61.1161 152.091 58.9381 153.754 56.6677 156.777C56.5885 156.882 56.6281 157.041 56.7469 157.093Z",
    fill: "#DAC4AD"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M249.269 75.055C256.289 75.055 261.98 69.3639 261.98 62.3434C261.98 55.323 256.289 49.6318 249.269 49.6318C242.248 49.6318 236.557 55.323 236.557 62.3434C236.557 69.3639 242.248 75.055 249.269 75.055Z",
    stroke: "#1DC7B2",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M241.93 62.7265L246.55 67.3465L255.301 58.8193",
    stroke: "#1DC7B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2858 75.055C88.3062 75.055 93.9974 69.3639 93.9974 62.3434C93.9974 55.323 88.3062 49.6318 81.2858 49.6318C74.2654 49.6318 68.5742 55.323 68.5742 62.3434C68.5742 69.3639 74.2654 75.055 81.2858 75.055Z",
    stroke: "#FD6D6D",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5205 57.6577L86.2489 67.3861",
    stroke: "#FD6D6D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2489 57.6577L76.5205 67.3861",
    stroke: "#FD6D6D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTakePhotoCover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/take-photo-cover.75046fc139a91b01177cf0cf06bf6a78.svg";